import { Routes, Route, Navigate } from "react-router-dom";
import usePrivilegeCheck from "@common/hooks/usePrivilegeCheck";
import { List } from "./List/List";
import { New } from "./New/New";
import { Edit } from "./Edit/Edit";

const PhasesMspa = () => {
  const { hasPrivilege } = usePrivilegeCheck();
  if (!hasPrivilege("settings.project_phases", ["manage"])) {
    return <div className="p-3">You do not have access to Project Phases.</div>;
  }

  return (
    <Routes>
      <Route index element={<List />} />
      <Route path="new" element={<New />} />
      <Route path=":id/edit" element={<Edit />} />
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
};

export default PhasesMspa;
